import React from 'react';
import DshImage from './images/dashboard.png';

const Image1 = () => {
    return (
        <div>
            <img src={DshImage} alt="Dashboard" style={{ width: "75vw" }} />
        </div>
    )
}

export default Image1
